import { RadicarComponent } from './radicar/radicar.component';
import { PqrSearchComponent } from './pqr-search/pqr-search.component';
import { HomeComponent } from './home/home.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'consultar', component: PqrSearchComponent },
  { path: 'radicar', component: RadicarComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
